/*
 * Public API Surface of loadable
 */

export * from './lib/loadable.service';
export * from './lib/loadable.component';
export * from './lib/loadable.module';
export function matcher() {
  return null;
}
